import i18n from '@/i18n';
import { openChangelog } from '@/features/changelog/composables/useChangelog';

export default [
  {
    meta: {
      title: i18n.global.t('page_titles.changelog'),
      requiresAuth: true,
    },
    path: '/changelog',
    name: 'changelog',
    // Preserve old links without replacing the page underneath the sidebar.
    beforeEnter: (_to, from) => {
      openChangelog();
      return from.matched.length ? false : { path: '/', replace: true };
    },
  },
];
